export const TOGGLE_CONTENT_OVERLAY = 'TOGGLE_CONTENT_OVERLAY';
export const CLOSE_CONTENT_OVERLAY = 'CLOSE_CONTENT_OVERLAY';
export const SHOW_CONTENT_OVERLAY = 'SHOW_CONTENT_OVERLAY';

const toggle = showOverlay => ({
    type: TOGGLE_CONTENT_OVERLAY,
    payload: {
        showOverlay,
    },
});

export const toggleOverlay = () => (dispatch, getState) => {
    dispatch(toggle(!getState().contentOverlay.showOverlay));
};

export const closeOverlay = () => ({
    type: CLOSE_CONTENT_OVERLAY,
});

export const openOverlay = () => ({
    type: SHOW_CONTENT_OVERLAY,
});
